// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"1S26q":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "aifoH": "splide.d38d5f8e.js",
    "2NPNQ": "splide.1209191d.js",
    "44qB9": "gsap.16eeb1c6.js",
    "hTWoS": "ScrollTrigger.65185a03.js"
});

},{}],"8fRDC":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
require("ae2d2e804c55f8e6").then(function(param) {
    var _loop = function(i) {
        var splide = new Splide(sliders[i], {
            accessibility: true,
            keyboard: "focused",
            type: "fade",
            rewind: true,
            arrows: true,
            pagination: false,
            perPage: 1,
            reducedMotion: {
                speed: 0,
                rewindSpeed: 0
            }
        }).mount();
        // Remove non-standard aria-roledescription from region (role="region" is sufficient)
        sliders[i].removeAttribute('aria-roledescription');
        // Remove aria-live + orphaned aria-atomic from track since our counter handles announcements
        var track = sliders[i].querySelector('.splide__track');
        track === null || track === void 0 ? void 0 : track.removeAttribute('aria-live');
        track === null || track === void 0 ? void 0 : track.removeAttribute('aria-atomic');
        // Slide counter
        var block = sliders[i].closest(".content-gallery-carousel");
        var counter = block === null || block === void 0 ? void 0 : block.querySelector(".gallery-slide-counter");
        if (counter) {
            var total = splide.length;
            var update = function(index) {
                counter.textContent = "".concat(index + 1, " of ").concat(total);
            };
            update(splide.index);
            splide.on("move", function(newIndex) {
                return update(newIndex);
            });
        }
    };
    var Splide = param.Splide;
    // Variables
    var sliders = document.querySelectorAll(".content-gallery-carousel .splide");
    // Initializing Splider
    for(var i = 0; i < sliders.length; i++)_loop(i);
}).catch(function(err) {
    console.error(err);
});
// Cursor-following arrows
var galleryBlocks = document.querySelectorAll(".content-gallery-carousel");
galleryBlocks.forEach(function(block) {
    var leftArrow = block.querySelector(".cursor-left-arrow");
    var rightArrow = block.querySelector(".cursor-right-arrow");
    var prevBtn = block.querySelector(".splide__arrow--prev");
    var nextBtn = block.querySelector(".splide__arrow--next");
    if (!leftArrow || !rightArrow) return;
    block.addEventListener("mousemove", function(e) {
        var x = e.clientX;
        var y = e.clientY;
        leftArrow.style.transform = "translate(calc(".concat(x, "px - 50%), calc(").concat(y, "px - 50%))");
        rightArrow.style.transform = "translate(calc(".concat(x, "px - 50%), calc(").concat(y, "px - 50%))");
    });
    block.addEventListener("mouseleave", function() {
        leftArrow.style.opacity = "0";
        rightArrow.style.opacity = "0";
    });
    prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.addEventListener("mouseenter", function() {
        leftArrow.style.opacity = "1";
    });
    prevBtn === null || prevBtn === void 0 ? void 0 : prevBtn.addEventListener("mouseleave", function() {
        leftArrow.style.opacity = "0";
    });
    nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.addEventListener("mouseenter", function() {
        rightArrow.style.opacity = "1";
    });
    nextBtn === null || nextBtn === void 0 ? void 0 : nextBtn.addEventListener("mouseleave", function() {
        rightArrow.style.opacity = "0";
    });
});
Promise.all([
    require("bc7bde03de197800"),
    require("626ccb77914dd2b7")
]).then(function(param) {
    var _param = (0, _slicedToArray._)(param, 2), gsap = _param[0].gsap, ScrollTrigger = _param[1].ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);
    // Function to check if motion should be reduced
    var shouldReduceMotion = function() {
        // Check system preference
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Check custom accessibility widget class
        var widgetReduceMotion = document.documentElement.classList.contains('reduce-motion');
        return prefersReducedMotion || widgetReduceMotion;
    };
    // Only run animation on screens wider than 1023px AND if user hasn't requested reduced motion
    var mm = gsap.matchMedia();
    mm.add("(min-width: 1024px)", function() {
        document.querySelectorAll('.content-gallery-carousel').forEach(function(wrapper) {
            try {
                // Ensure we're only working with elements in the main document (not iframes)
                if (wrapper.ownerDocument !== document) return;
                if (wrapper.classList.contains('no-animate')) {
                    gsap.set(wrapper.querySelector('section > div'), {
                        clipPath: 'none'
                    });
                    return;
                }
                // Target the main content container that includes both text and gallery
                var blockContent = wrapper.querySelector('section > div');
                if (!blockContent) return;
                // If user prefers reduced motion, skip animation and ensure content is visible
                if (shouldReduceMotion()) {
                    gsap.set(blockContent, {
                        clipPath: 'none'
                    });
                    return;
                }
                // Set initial state: circle mask at 0% from bottom center (fully hidden)
                gsap.set(blockContent, {
                    clipPath: 'circle(25% at 50% 100%)'
                });
                // Animate the circle expanding from bottom to reveal content
                var animation = gsap.to(blockContent, {
                    clipPath: 'circle(100% at 50% 100%)',
                    scrollTrigger: {
                        trigger: wrapper,
                        start: '50% bottom',
                        end: '120% bottom',
                        scrub: 1,
                        invalidateOnRefresh: true,
                        markers: false
                    }
                });
                // Listen for accessibility widget changes
                var observer = new MutationObserver(function() {
                    if (document.documentElement.classList.contains('reduce-motion')) {
                        var // Kill animation and show content
                        _animation_scrollTrigger;
                        (_animation_scrollTrigger = animation.scrollTrigger) === null || _animation_scrollTrigger === void 0 ? void 0 : _animation_scrollTrigger.kill();
                        animation.kill();
                        gsap.set(blockContent, {
                            clipPath: 'none'
                        });
                    }
                });
                observer.observe(document.documentElement, {
                    attributes: true,
                    attributeFilter: [
                        'class'
                    ]
                });
            } catch (error) {
                // Silently handle cross-origin or permission errors without breaking the page
                console.warn('ScrollTrigger initialization skipped for element:', error.message);
            }
        });
    });
}).catch(console.error);

},{"@swc/helpers/_/_sliced_to_array":"lIMjm","ae2d2e804c55f8e6":"btIxh","bc7bde03de197800":"gptmF","626ccb77914dd2b7":"k9Jsr"}],"lIMjm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"2a4lV","./_iterable_to_array_limit.js":"87XEK","./_non_iterable_rest.js":"fFxaZ","./_unsupported_iterable_to_array.js":"kVlF5","@parcel/transformer-js/src/esmodule-helpers.js":"cBpoQ"}],"2a4lV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"cBpoQ"}],"cBpoQ":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"87XEK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"cBpoQ"}],"fFxaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"cBpoQ"}],"kVlF5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"3oX4q","@parcel/transformer-js/src/esmodule-helpers.js":"cBpoQ"}],"3oX4q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"cBpoQ"}],"btIxh":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("cde66c3df8638403")(module.bundle.resolve("2NPNQ")),
    require("cde66c3df8638403")(module.bundle.resolve("aifoH"))
]).then(function() {
    return module.bundle.root('7s80R');
});

},{"cde66c3df8638403":"1MWbm"}],"1MWbm":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"4yBbG"}],"4yBbG":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"gptmF":[function(require,module,exports,__globalThis) {
module.exports = require("4d79c81585d469c8")(module.bundle.resolve("44qB9")).then(function() {
    return module.bundle.root('1vKI8');
});

},{"4d79c81585d469c8":"1MWbm"}],"k9Jsr":[function(require,module,exports,__globalThis) {
module.exports = require("127ef20cab9c6384")(module.bundle.resolve("hTWoS")).then(function() {
    return module.bundle.root('5OkEZ');
});

},{"127ef20cab9c6384":"1MWbm"}]},["1S26q","8fRDC"], "8fRDC", "parcelRequired6e5", {}, "../../../../", "/")

//# sourceMappingURL=content-gallery-carousel.js.map
